import type {
    CategoryFilterType,
    FilterStates,
} from '~/modules/magazine/type/filter-states';

import { DigitalMagazineOptions, BASE_URL } from '../configs/constants';

export const getMagazineKeyByEnum = (e: CategoryFilterType): string =>
    DigitalMagazineOptions.find((o) => o.searchEnum === e)?.key ??
    DigitalMagazineOptions['0']?.key ??
    '';

export const getUrlByFilterStates = (state: FilterStates): string => {
    const { year, month, categoryEnum } = state;

    const key = getMagazineKeyByEnum(categoryEnum);

    const dateFilter = year ? `/${year}${month ? `/${month}` : ''}` : '';
    const categoryFilter = categoryEnum ? `?sort=${key}` : '?sort=all';

    return `${BASE_URL}${dateFilter}${categoryFilter}`;
};
